import React from "react";
import { connect } from "react-redux";
import { MetypeFeedWidget } from "@metype/components";
import get from "lodash/get";
import { isEmpty } from "../utils";

function MetypeBase(props) {
  const publisherName = get(props, ["config", "publisher-name"]);
  const metypeConfig = get(props, ["config", "theme-attributes", "metype-config"], {});

  if (isEmpty(metypeConfig)) return null;

  return (
    <MetypeFeedWidget
      host={metypeConfig.host}
      accountId={parseInt(metypeConfig.accountId)}
      publisher={publisherName}
      primaryColor={metypeConfig.primaryColor}
      className={metypeConfig.className || ""}
      secondaryColor={metypeConfig.bgColor}
      fontColor={metypeConfig.fontColor}
    />
  );
}

function mapStateToProps(state) {
  return {
    config: state.qt.config || {}
  };
}

const Metype = connect(
  mapStateToProps,
  {}
)(MetypeBase);

export { Metype };
